<template>
  <v-card
    elevation="4"
    outlined
  >
    <v-card-subtitle class="pl-2 pb-2 pt-3">
      Lista de parâmetros:
    </v-card-subtitle>

    <v-divider></v-divider>

    <v-form
      ref="formRef"
      class="multi-col-validation"
      @submit.prevent="handleOnSubmitBtnClick"
    >
      <v-row class="d-flex mt-1 px-2">
        <v-col cols="6">
          <v-text-field
            ref="parametroInputRef"
            v-model="parametroASerAdicionado.nome"
            dense
            outlined
            clearable
            label="Parâmetro"
            counter="2000"
            validate-on-blur
            hint="Máximo de 2000 caracteres"
            persistent-hint
            :rules="[validators.required, (v) => (!!v && v.length <= 2000) || 'Máximo de 2000 caracteres']"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            ref="parametroInputRef"
            v-model="parametroASerAdicionado.pergunta"
            dense
            outlined
            clearable
            label="Pergunta"
            counter="2000"
            validate-on-blur
            hint="Máximo de 2000 caracteres"
            persistent-hint
            :rules="[validators.required, (v) => (!!v && v.length <= 2000) || 'Máximo de 2000 caracteres']"
          />
        </v-col>

        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            color="primary"
            type="submit"
            @click="adicionarParametro"
          >
            Adicionar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-data-table
      class="mt-2"
      :headers="headers"
      :items="parametrosDataLocale"
      hide-default-header
      hide-default-footer
      no-data-text="Nenhum parâmetro adicionado"
    >
      <template v-slot:item.actions="{ index }">
        <div class="d-flex justify-end">
          <v-icon @click="removerParametro(index)">
            {{ icons.mdiDelete }}
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiDelete } from '@mdi/js'
import { required } from '@/@core/utils/validation'

export default {
  props: {
    parametros: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit }) {
    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Pergunta', value: 'pergunta' },
      { text: 'Actions', value: 'actions' },
    ]

    const parametrosDataLocale = ref([])

    watch(
      () => props.parametros,
      v => {
        if (!v) {
          parametrosDataLocale.value = []
          return
        }

        parametrosDataLocale.value = JSON.parse(JSON.stringify(v))
      },
      { immediate: true },
    )

    const parametroInputRef = ref(null)
    const parametroASerAdicionado = ref({
      nome: '',
      pergunta: '',
    })

    const nomePossui2000CaracteresOuMenos = computed(() => parametroASerAdicionado.value.nome.length <= 2000)
    const itemJaFoiAdicionado = computed(() => parametrosDataLocale.value
      .find(o => o.nome.toLowerCase() === parametroASerAdicionado.value.nome.toLowerCase()))

    function updateParametros() {
      emit('update:parametros', parametrosDataLocale.value)
    }

    function adicionarParametro() {
      if (parametroASerAdicionado.value.nome && nomePossui2000CaracteresOuMenos.value && !itemJaFoiAdicionado.value) {
        parametrosDataLocale.value.push({ ...parametroASerAdicionado.value })
        parametroASerAdicionado.value.nome = ''
        parametroASerAdicionado.value.pergunta = ''
        updateParametros()
      } else {
        parametroInputRef.value.focus()
      }
    }

    function removerParametro(index) {
      parametrosDataLocale.value.splice(index, 1)
      updateParametros()
    }

    async function handleOnSubmitBtnClick() {

    }

    return {
      headers,
      parametrosDataLocale,
      parametroInputRef,
      parametroASerAdicionado,
      adicionarParametro,
      removerParametro,
      handleOnSubmitBtnClick,
      icons: {
        mdiDelete,
      },
      validators: {
        required,
      },
    }
  },
}
</script>
